import { render, staticRenderFns } from "./BundleUpdate.vue?vue&type=template&id=1e734f18&"
import script from "./BundleUpdate.vue?vue&type=script&lang=js&"
export * from "./BundleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports